import React, {useState} from "react";
import {DownloadOutlined, PlusOutlined} from "@ant-design/icons";
import {useTranslation} from "react-i18next";
import {ActionButtonsContainer} from "./ActionButtons.styles";
import {CustomButton} from "../../../_defaultComponents/CustomButton/CustomButton";
import {message, Tooltip} from "antd";
import {AssignEquipmentModal} from "../modals/assignEquipmentModal/AssignEquipmentModal";
import {b64DecodeToUrl} from "utils/helpers";
import {useStore} from "hooks/useStore";

const ActionButtons = ({
    recall = () => {},
    selectedCouriers = [],
    onCourierRemove = () => {},
    onEquipmentAssigned = () => {},
    filters = {}
}) => {
    const stores = useStore();
    const {t} = useTranslation([]);
    const [showAssignEquipmentModal, setShowAssignEquipmentModal] = useState(false);
    const [exportLoading, setExportLoading] = useState(false);
    const openAssignEquipmentModal = () => {
        setShowAssignEquipmentModal(true);
    };

    const closeAssignEquipmentModal = ({equipmentAssignedCouriers = []}) => {
        setShowAssignEquipmentModal(false);
        onEquipmentAssigned({updatedRecords: equipmentAssignedCouriers || []});
    };

    const exportCourierEquipments = async () => {
        setExportLoading(true);
        try {
            const response = await stores.equipmentStore.exportCourierEquipments({
                ...filters
            });

            if (response?.success) {
                const fileName = response?.data?.fileName;
                const base64Data = response?.data?.base64Excel;
                const url = await b64DecodeToUrl(base64Data);
                const link = document.createElement("a");
                link.href = url;
                link.download = fileName;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                message.success("Excel dosyası başarıyla indirildi.");
            }
        } catch (error) {
            message.error("Excel dosyası oluşturulurken bir hata oluştu.");
        } finally {
            setExportLoading(false);
        }
    };

    return (
        <>
            <ActionButtonsContainer>
                <Tooltip title={"Excel Çıktı Al"}>
                    <CustomButton
                        type="primary"
                        data-testid="exportCourierEquipments"
                        onClick={exportCourierEquipments}
                        icon={<DownloadOutlined />}
                        loading={exportLoading}
                    >
                        {"Excel Çıktı Al"}
                    </CustomButton>
                </Tooltip>
                <Tooltip title={"Seçili Kuryelere Ekipman Ata"}>
                    <CustomButton
                        type="primary"
                        data-testid="assignEquipment"
                        onClick={openAssignEquipmentModal}
                        icon={<PlusOutlined />}
                        disabled={selectedCouriers?.length === 0}
                    >
                        {`Seçili Kuryeler (${selectedCouriers?.length || 0})`}
                    </CustomButton>
                </Tooltip>
            </ActionButtonsContainer>

            {/* Modals */}
            <AssignEquipmentModal
                visibility={showAssignEquipmentModal}
                changeVisibility={setShowAssignEquipmentModal}
                onCancel={() => closeAssignEquipmentModal({equipmentAssignedCouriers: []})}
                onOk={({equipmentAssignedCouriers}) =>
                    closeAssignEquipmentModal({equipmentAssignedCouriers})
                }
                selectedCouriers={selectedCouriers}
                onCourierRemove={onCourierRemove}
                onEquipmentAssigned={onEquipmentAssigned}
            />
        </>
    );
};

export default ActionButtons;
